<div class="dash-container container">

  <!-- ════════════════ PAGE HEADER ════════════════ -->
  <div class="dash-page-header">
    <div class="dph-left">
      <div class="dph-badge">
        <i class="fa-solid fa-hand-holding-heart"></i> Histórico de Contribuições
      </div>
      <h1 class="dph-title">Minhas Doações e Apoios</h1>
      <p class="dph-subtitle">
        Consulte o histórico de todos os donativos realizados, verifique os comprovativos e acompanhe o estado dos
        pagamentos.
      </p>
    </div>

    <div class="dph-actions">
      <a routerLink="/campanhas" class="btn btn-primary">
        <i class="fa-solid fa-compass"></i> Explorar Mais Causas
      </a>
    </div>
  </div>

  <!-- ════════════════ KPI CARDS ════════════════ -->
  <div class="kpi-grid">
    <!-- Total Doado -->
    <div class="kpi-card kpi-green">
      <div class="kpi-icon"><i class="fa-solid fa-hand-holding-dollar"></i></div>
      <div class="kpi-value">
        <ng-container *ngIf="!loadIndicators">{{ totalDoado | money }} Kz</ng-container>
        <p-skeleton width="5rem" height="1.8rem" *ngIf="loadIndicators"></p-skeleton>
      </div>
      <div class="kpi-label">Total Contribuído</div>
      <span class="kpi-delta up"><i class="fa-solid fa-heart"></i> Impacto directo</span>
    </div>

    <!-- Projectos Apoiados -->
    <div class="kpi-card kpi-blue">
      <div class="kpi-icon"><i class="fa-solid fa-layer-group"></i></div>
      <div class="kpi-value">
        <ng-container *ngIf="!loadIndicators">{{ totalProjetosApoiados }}</ng-container>
        <p-skeleton width="3rem" height="1.8rem" *ngIf="loadIndicators"></p-skeleton>
      </div>
      <div class="kpi-label">Campanhas Apoiadas</div>
      <span class="kpi-delta neu"><i class="fa-solid fa-bullhorn"></i> Projectos únicos</span>
    </div>

    <!-- Número de Doações -->
    <div class="kpi-card kpi-purple">
      <div class="kpi-icon"><i class="fa-solid fa-receipt"></i></div>
      <div class="kpi-value">
        <ng-container *ngIf="!loadIndicators">{{ totalApoios | number }}</ng-container>
        <p-skeleton width="3rem" height="1.8rem" *ngIf="loadIndicators"></p-skeleton>
      </div>
      <div class="kpi-label">Transacções Feitas</div>
      <span class="kpi-delta neu"><i class="fa-solid fa-clock-rotate-left"></i> Histórico total</span>
    </div>

    <!-- Concluídas / Aprovadas -->
    <div class="kpi-card kpi-amber">
      <div class="kpi-icon"><i class="fa-solid fa-circle-check"></i></div>
      <div class="kpi-value">
        <ng-container *ngIf="!loadIndicators">{{ totalApoios | number }}</ng-container>
        <p-skeleton width="3rem" height="1.8rem" *ngIf="loadIndicators"></p-skeleton>
      </div>
      <div class="kpi-label">Apoios Confirmados</div>
      <span class="kpi-delta up"><i class="fa-solid fa-check-double"></i> Concluídos</span>
    </div>
  </div>

  <!-- ════════════════ FILTERS BAR ════════════════ -->
  <div class="filter-card">
    <div class="filter-card-header">
      <span class="fch-title"><i class="fa-solid fa-filter"></i> Filtrar Pagamentos</span>
      <span class="fch-badge" *ngIf="pagination.totalRecords">{{ pagination.totalRecords }} registo(s)</span>
    </div>

    <form [formGroup]="formFilters" class="filter-form-grid">
      <!-- Data -->
      <div class="filter-field">
        <label for="DataCriacao">Data do Pagamento</label>
        <p-datepicker formControlName="DataCriacao" class="w-full" [showIcon]="true" dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa" [showClear]="true" appendTo="body" />
      </div>

      <!-- Método -->
      <div class="filter-field">
        <label for="MetodoPagamentoENUM">Método de Pagamento</label>
        <p-select formControlName="MetodoPagamentoENUM" class="w-full" placeholder="Todos os métodos"
          [options]="metodoList" optionLabel="label" optionValue="id" [showClear]="true" />
      </div>

      <!-- Estado -->
      <div class="filter-field">
        <label for="EstadoPagamentoENUM">Estado do Pagamento</label>
        <p-select formControlName="EstadoPagamentoENUM" class="w-full" placeholder="Todos os estados"
          [options]="estadoList" optionLabel="label" optionValue="id" [showClear]="true" />
      </div>
    </form>
  </div>

  <!-- ════════════════ LISTAGEM ════════════════ -->
  <div class="table-card">
    <div class="table-card-header">
      <span class="tch-title">Lista de Apoios e Pagamentos</span>
      <span class="tch-sub">Clique em qualquer item para ver o comprovativo completo</span>
    </div>

    <!-- SKELETON LOADING -->
    <ng-container *ngIf="loading">
      <div class="table-loading-wrap">
        <app-skeleton-loader [count]="4" type="card-campanha-dash"></app-skeleton-loader>
      </div>
    </ng-container>

    <!-- DATA LIST -->
    <ng-container *ngIf="!loading">
      <ng-container *ngIf="pagination.data?.length; else noData">
        <div class="list-cards-wrap">
          <app-card-doacao *ngFor="let item of pagination.data" [dados]="item" [codigo]="item.apoioID"
            [titulo]="item?.apoio?.campanha?.titulo" [data]="item?.dataCriacaoFormatada"
            [Objectivo]="item?.apoio?.campanha?.metaArrecadar" [doado]="item?.apoio?.valorApoio"
            [estado]="item.estadoPagamento" [actions]="getActionsByEstado(item)" (rowClick)="viewDetails(item)"
            (menuOpened)="setOpenedMenu($event)" />
        </div>

        <div class="pagination-footer">
          <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
            [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
            (pageChange)="onPageChange($event)" />
        </div>
      </ng-container>

      <ng-template #noData>
        <div class="no-data-wrap">
          <app-data-void titulo="Nenhum apoio encontrado"
            descricao="Ainda não realizou nenhum donativo com os filtros selecionados. Comece hoje a apoiar projectos incríveis em Angola!" />
          <div class="no-data-cta">
            <a [routerLink]="['/campanhas']" (click)="explorarCampanhas()"
              class="btn btn-primary btn-rounded cursor-pointer">
              <i class="fa-solid fa-compass"></i> Explorar Campanhas
            </a>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>

</div>

<!-- ════════════════ DRAWER DE DETALHES ════════════════ -->
<p-drawer [(visible)]="showDetalhesPagamento" position="right" [style]="{ width: '95vw', 'max-width': '650px' }"
  styleClass="!w-full md:!w-80 lg:!w-[32rem]" appendTo="body" [blockScroll]="true" [modal]="true">
  <ng-template #headless>
    @if (pagamentoID) {
    <div class="drawer-body">
      <app-detalhe-pagamento [pagamentoID]="pagamentoID" (onCloseModal)="showDetalhesPagamento = false" />
    </div>
    }
  </ng-template>
</p-drawer>

<!-- ════════════════ DIALOG DE SOLICITAÇÃO DE REEMBOLSO ════════════════ -->
<p-dialog header="Solicitar Reembolso do Apoio" [(visible)]="showDialogReembolso" [modal]="true" [closable]="true"
  [style]="{ width: '92vw', 'max-width': '580px' }" (onHide)="fecharDialogReembolso()" appendTo="body">
  <div class="reembolso-dialog-body" *ngIf="selectedPagamentoReembolso">
    <!-- Resumo do Apoio -->
    <div class="rd-card-summary">
      <div class="rd-summary-header">
        <span class="rd-code">Apoio #{{ selectedPagamentoReembolso?.apoioID || selectedPagamentoReembolso?.id }}</span>
        <span class="rd-status"><i class="fa-solid fa-circle-check"></i> {{ selectedPagamentoReembolso?.estadoPagamento
          || 'Confirmado' }}</span>
      </div>
      <h3 class="rd-campaign-title">{{ selectedPagamentoReembolso?.apoio?.campanha?.titulo || 'Campanha Apoiada' }}</h3>
      <div class="rd-summary-grid">
        <div class="rd-metric">
          <span class="rd-lbl">Valor Apoiado</span>
          <strong class="rd-val highlight">{{ selectedPagamentoReembolso?.apoio?.valorApoio | money }} Kz</strong>
        </div>
        <div class="rd-metric">
          <span class="rd-lbl">Data do Pagamento</span>
          <span class="rd-val">{{ selectedPagamentoReembolso?.dataCriacaoFormatada }}</span>
        </div>
      </div>
    </div>

    <!-- Banner Informativo -->
    <div class="rd-info-box">
      <i class="fa-solid fa-shield-halved rd-info-icon"></i>
      <div class="rd-info-text">
        <strong>Política de Donativos e Reembolsos:</strong>
        <p>Os apoios confirmados são alocados aos promotores dos projectos. Qualquer pedido de estorno ou cancelamento
          excepcional é submetido à equipa de suporte e conformidade da FundCube para validação.</p>
      </div>
    </div>

    <!-- Formulário -->
    <form [formGroup]="formReembolso" class="rd-form" (ngSubmit)="submeterPedidoReembolso()">
      <div class="form-group mb-3">
        <label class="form-label" for="motivoReembolso">Motivo da Solicitação <span class="text-danger">*</span></label>
        <p-select id="motivoReembolso" formControlName="motivo" [options]="motivosReembolso" optionLabel="label"
          optionValue="value" placeholder="Selecione o motivo" class="w-full" />
      </div>

      <div class="form-group mb-3">
        <label class="form-label" for="descReembolso">Justificação / Detalhes <span class="text-danger">*</span></label>
        <textarea id="descReembolso" rows="3" pTextarea formControlName="descricao"
          placeholder="Descreva o que motivou este pedido (mínimo 10 caracteres)..."
          class="w-full form-textarea"></textarea>
        <small class="field-error"
          *ngIf="formReembolso.get('descricao')?.invalid && formReembolso.get('descricao')?.touched">
          <i class="fa-solid fa-triangle-exclamation"></i> Por favor informe os detalhes da solicitação (mínimo 10
          caracteres).
        </small>
      </div>

      <div class="rd-dialog-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="contactarSuporteReembolso()"
          title="Abrir e-mail com dados pré-preenchidos">
          <i class="fa-regular fa-envelope"></i> Falar via E-mail
        </button>
        <div class="rd-actions-right">
          <button type="button" class="btn btn-ghost" (click)="fecharDialogReembolso()">
            Cancelar
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="loadingReembolso || formReembolso.invalid">
            <i class="fa-solid fa-spinner fa-spin" *ngIf="loadingReembolso"></i>
            <i class="fa-solid fa-paper-plane" *ngIf="!loadingReembolso"></i>
            Enviar Pedido
          </button>
        </div>
      </div>
    </form>
  </div>
</p-dialog>